import { Country } from '@superbet-group/web.types';
import { AsyncComponent } from 'vue';

export function getCountryActivateAccountMainButton(_country: Country): AsyncComponent {
    return () => import('@accountCountries/registration/components/ActivateAccountMainButton.vue');
}
